// import React, { useEffect, useState } from 'react';
// import './StallItem.scss';
// import Card from '@material-ui/core/Card';
// import dummyImage from "./../../../assets/images/dummy.png";
// import { AlertService, FxCurrency, FxPopup } from '../../fx-core';
// import { Button, makeStyles, Dialog } from '@material-ui/core';
// import Drawer from '@material-ui/core/Drawer';
// import RegisterComponent from '../../RegisterComponent/RegisterComponent';
// import { useDispatch, useSelector } from 'react-redux';
// import CustomizeForm from '../CustomizeForm/CustomizeForm';
// import * as _ from 'lodash';
// import info from "../../../assets/info.png";
// import ImageSlides from '../../general/ImageSlides/ImageSlides';
// // add this import near the others
// import ItemCustomizeAlert from '../ItemCustomizeAlert/ItemCustomizeAlert';

// const styles = makeStyles((theme) => ({
//   drawerWidth: {
//     [theme.breakpoints.down(599)]: {
//       width: '90%'
//     },
//     [theme.breakpoints.up(600)]: {
//       width: '70%'
//     },
//     [theme.breakpoints.up(1025)]: {
//       width: '35%'
//     }
//   }
// }));

// const StallItem = (props: any) => {
//   const classes = styles();
//   const dispatch = useDispatch();
//   const cartInfo = useSelector<any, any>(store => store.cart);
//   const cart = cartInfo;
//   const listingCartData = useSelector<any, any>(s => s.listingCart);
//   const [registerComponentFormOpen, setRegisterComponentFormOpen] = useState(false);
//   const [customizeFormOpen, setCustomizeFormOpen] = useState(false);
//   const [stallItemBatchId, setStallItemBatchId] = useState(0);
//   const [stallItemId, setStallItemId] = useState(0);
//   const [imageSlideOpen, setImageSlideOpen] = useState(false);
//   const [imageConfig, setImageConfig] = useState({});  
//   const [deliveryTime, setDeliveryTime] = useState(props.item.stallitem.deliveryTime);
//   const [deliveryTimeUnits, setDeliveryTimeUnits] = useState(props.item.stallitem.deliveryTimeUnits);
//   console.log("deliveryTimeUnits", deliveryTime, deliveryTimeUnits);

//   // Alert dialog for quantity rules
//   const [qtyAlertOpen, setQtyAlertOpen] = useState(false);
//   const [qtyAlertMessage, setQtyAlertMessage] = useState<any[]>([]);

//   // Cart replacement confirmation
//   const [showCartReplaceConfirm, setShowCartReplaceConfirm] = useState(false);
//   const [pendingCartAction, setPendingCartAction] = useState<any>(null);
//   const [currentStallName, setCurrentStallName] = useState('');
//   const [newStallName, setNewStallName] = useState('');

//   const handleRegisterComponentForm = () => {
//     setRegisterComponentFormOpen(false);
//   };

//   const openRegisterComponentFormOpen = () => {
//     setRegisterComponentFormOpen(true);
//   };

//   const openStallLinkUrl = (prod: any) => {
//     window.open(props.stallLinkUrl, '_blank');
//   };

//   // Check if adding item from different stall
//   const isDifferentStall = () => {
//     return cartInfo.stallId > 0 && props.stallId !== cartInfo.stallId && cartInfo.items.length > 0;
//   };

//   // Show cart replacement confirmation
//   const showCartReplaceConfirmation = (actionType: string, item: any, stallName: string) => {
//     setPendingCartAction({ actionType, item });
//     setCurrentStallName(cartInfo.stallName || 'Current Stall');
//     setNewStallName(stallName || props.item.stalltemBatch.stallName || 'New Stall');
//     setShowCartReplaceConfirm(true);
//   };

//   // Handle confirmation to replace cart
//   const handleConfirmReplaceCart = () => {
//     if (pendingCartAction) {
//       const { actionType, item } = pendingCartAction;
      
//       // Clear current cart and add new item
//       dispatch({ type: "CLEAR_CART", payload: {} });
      
//       if (actionType === 'add') {
//         // For add action with min quantity logic
//         const maxLimit = getEffectiveMax(item);
//         const minLimit = getMinLimit(item);
//         const currentQty = 0; // Starting fresh

//         if (currentQty === 0 && typeof minLimit === 'number' && minLimit > 1) {
//           const target = typeof maxLimit === 'number' ? Math.min(minLimit, maxLimit) : minLimit;
//           for (let i = 0; i < target; i++) {
//             dispatch({
//               type: "ADD_CART",
//               payload: { 
//                 stallId: props.stallId, 
//                 stallName: props.stallName || props.item.stalltemBatch.stallName,
//                 item: { 
//                   ...item, 
//                   isTreasureHunt: props.item.stallitem?.isTreasureHunt || 0,
//                   deliveryTime: deliveryTime || 0,
//                   deliveryTimeUnits: deliveryTimeUnits || 1
//                 }
//               }
//             });
//           }
//         } else {
//           // Normal add
//           dispatch({
//             type: "ADD_CART",
//             payload: { 
//               stallId: props.stallId, 
//               stallName: props.stallName || props.item.stalltemBatch.stallName,
//               item: { 
//                 ...item, 
//                 isTreasureHunt: props.item.stallitem?.isTreasureHunt || 0,
//                 deliveryTime: deliveryTime || 0,
//                 deliveryTimeUnits: deliveryTimeUnits || 1
//               }
//             }
//           });
//         }
//       } else if (actionType === 'customize') {
//         // Handle customization
//         setStallItemBatchId(item.id);
//         setStallItemId(item.stallItemId);
//         setCustomizeFormOpen(true);
//       }
//     }
//     setShowCartReplaceConfirm(false);
//     setPendingCartAction(null);
//   };

//   // Handle cancel cart replacement
//   const handleCancelReplaceCart = () => {
//     setShowCartReplaceConfirm(false);
//     setPendingCartAction(null);
//   };

//   const reduceQtyFromCart = (item: any, deliveryTimeParam = deliveryTime, deliveryTimeUnitsParam = deliveryTimeUnits) => {
//     getModifierAmount(item);

//     const minLimit = getMinLimit(item);
//     const currentQty = getCartQty(item);
//     const nextQty = currentQty - 1;

//     if (typeof minLimit === 'number' && nextQty < minLimit) {
//       return;
//     }

//     dispatch({ 
//       type: "REDUCE_CART", 
//       payload: { 
//         stallId: props.stallId, 
//         item, 
//         deliveryTime: deliveryTimeParam || 0,
//         deliveryTimeUnits: deliveryTimeUnitsParam || 1
//       } 
//     });
//   };

//   const addQtyToCart = (item: any, deliveryTimeParam = deliveryTime, deliveryTimeUnitsParam = deliveryTimeUnits) => {
//     console.log("addQtyToCart", item, deliveryTimeParam, deliveryTimeUnitsParam);
//     getModifierAmount(item);

//     // Check if different stall and show confirmation
//     if (isDifferentStall()) {
//       showCartReplaceConfirmation('add', item, props.stallName || props.item.stalltemBatch.stallName);
//       return;
//     }

//     const maxLimit = getEffectiveMax(item);
//     const minLimit = getMinLimit(item);
//     const currentQty = getCartQty(item);

//     // Already capped?
//     if (typeof maxLimit === 'number' && currentQty >= maxLimit) {
//       showWarn(`You can't add more than ${maxLimit} for this item.`);
//       return;
//     }

//     // First add and min > 1: jump to min (but don't exceed max/stock)
//     if (currentQty === 0 && typeof minLimit === 'number' && minLimit > 1) {
//       const target = typeof maxLimit === 'number' ? Math.min(minLimit, maxLimit) : minLimit;

//       if (listingCartData.cartCount > 0) {
//         dispatch({ type: "CLEAR_LISTING_CART", payload: {} });
//       }
//       for (let i = 0; i < target; i++) {
//         dispatch({
//           type: "ADD_CART",
//           payload: { 
//             stallId: props.stallId, 
//             stallName: props.stallName || props.item.stalltemBatch.stallName,
//             item: { 
//               ...item, 
//               isTreasureHunt: props.item.stallitem?.isTreasureHunt || 0,
//               deliveryTime: deliveryTimeParam || 0,
//               deliveryTimeUnits: deliveryTimeUnitsParam || 1
//             }
//           }
//         });
//       }
//       return;
//     }

//     // Normal +1 with cap
//     const nextQty = currentQty + 1;
//     if (typeof maxLimit === 'number' && nextQty > maxLimit) {
//       showWarn(`You can't add more than ${maxLimit} for this item.`);
//       return;
//     }

//     if (listingCartData.cartCount > 0) {
//       dispatch({ type: "CLEAR_LISTING_CART", payload: {} });
//     }
//     dispatch({
//       type: "ADD_CART",
//       payload: { 
//         stallId: props.stallId, 
//         stallName: props.stallName || props.item.stalltemBatch.stallName,
//         item: { 
//           ...item, 
//           isTreasureHunt: props.item.stallitem?.isTreasureHunt || 0,
//           deliveryTime: deliveryTimeParam || 0,
//           deliveryTimeUnits: deliveryTimeUnitsParam || 1
//         }
//       }
//     });
//   };

//   const getModifierAmount = (item: any) => {
//     if (item.customizedDetails && item.customizedDetails.length > 0) {
//       let totalModifierAmt = _.sumBy(item.customizedDetails, 'stallItemCustomizeDetailPrice');
//       item.modifierAmt = totalModifierAmt;
//     }
//   };

//   const openCustomizeForm = (item: any) => {
//     // Check if different stall and show confirmation
//     if (isDifferentStall()) {
//       showCartReplaceConfirmation('customize', item, props.stallName);
//       return;
//     }

//     const maxLimit = getEffectiveMax(item);
//     const currentQty = Number(item?.quantity ?? 0);
//     if (typeof maxLimit === 'number' && currentQty >= maxLimit) {
//       showWarn(`You can't add more than ${maxLimit} for this item.`);
//       return;
//     }
//     setStallItemBatchId(item.id);
//     setStallItemId(item.stallItemId);
//     setCustomizeFormOpen(true);
//   };

//   const closeCustomizeForm = () => {
//     setCustomizeFormOpen(false);
//   };

//   const handleCustomizedDetails = (data: any, id: any) => {
//     setCustomizeFormOpen(false);
//     props.handleStallItemCustomized(data, id, deliveryTime, deliveryTimeUnits);
//   };

//   const openImages = (item: any) => {
//     let config = {
//       api: `portal/stallitem/${item.id}/images`,
//       title: item.title
//     };
//     setImageConfig(config);
//     setImageSlideOpen(true);
//   };

//   const handleImageSlideClose = () => {
//     setImageSlideOpen(false);
//   };

//   const getMaxLimit = (item: any): number | undefined => {
//     const max = Number(item?.maximumQuantity);
//     return Number.isFinite(max) && max > 0 ? max : undefined;
//   };

//   const getMinLimit = (item: any): number | undefined => {
//     const min = Number(item?.minimumQuantity);
//     return Number.isFinite(min) && min >= 0 ? min : undefined;
//   };

//   // If you also want to cap by available stock:
//   const getEffectiveMax = (item: any): number | undefined => {
//     const maxLimit = getMaxLimit(item);
//     const stock = Number(item?.currentQuantity);
//     const stockCap = Number.isFinite(stock) && stock > 0 ? stock : undefined;
//     if (typeof maxLimit === 'number' && typeof stockCap === 'number') return Math.min(maxLimit, stockCap);
//     return (typeof maxLimit === 'number') ? maxLimit : stockCap;
//   };

//   // keep the SAME name:
//   const showWarn = (
//     msgOrList: string | { groupName: string; message: string }[],
//     groupName: string = 'Quantity'
//   ) => {
//     if (Array.isArray(msgOrList)) {
//       setQtyAlertMessage(msgOrList);
//     } else {
//       setQtyAlertMessage([{ groupName, message: msgOrList }]);
//       if ((AlertService as any)?.warn) (AlertService as any).warn(msgOrList);
//     }
//     setQtyAlertOpen(true);
//   };

//   // Try to resolve the same line items in cart that match this batch
//   const getCartQty = (batch: any): number => {
//     const sid = props.stallId;
//     const batchId = batch?.id;
//     const stallItemId = batch?.stallItemId;

//     const root = cartInfo || {};
//     const lines =
//       Array.isArray(root.items) ? root.items :
//       Array.isArray(root) ? root :
//       Array.isArray(root?.[sid]?.items) ? root[sid].items :
//       [];

//     return lines
//       .filter((l: any) =>
//         (l?.id ?? l?.stallItemBatchId) === batchId || l?.stallItemId === stallItemId
//       )
//       .reduce((sum: number, l: any) => sum + Number(l?.quantity ?? 0), 0);
//   };

//   const openQtyAlert = () => setQtyAlertOpen(true);
  
//   const handleQtyAlertClose = () => {
//     setQtyAlertOpen(false);
//     setQtyAlertMessage([]);
//   };

//   const batch = props.item.stalltemBatch;
//   const maxLimit = getEffectiveMax(batch);
//   const minLimit = getMinLimit(batch);
//   const qty = getCartQty(batch);

//   const atMax = typeof maxLimit === 'number' && qty >= maxLimit;
//   const atMin = typeof minLimit === 'number' && qty <= minLimit;

//   useEffect(() => {
//     setDeliveryTime(props.item.stallitem.deliveryTime);
//     setDeliveryTimeUnits(props.item.stallitem.deliveryTimeUnits);
//   }, [props.item.stallitem.deliveryTime, props.item.stallitem.deliveryTimeUnits]);

//   return (
//     <div className="stallitem-ui">
//       {/* cart replacement confirmation dialog */}
//       <Dialog
//         open={showCartReplaceConfirm}
//         onClose={handleCancelReplaceCart}
//         aria-labelledby="cart-replace-confirm-title"
//         aria-describedby="cart-replace-confirm-description"
//       >
//         <div className="p-4">
//           <h4 id="cart-replace-confirm-title" className="mb-3">
//             Replace Cart Items?
//           </h4>
//           <p id="cart-replace-confirm-description" className="mb-4">
//             Your cart contains items from <strong>{currentStallName}</strong>. 
//             Do you want to replace them with items from <strong>{props.item.stalltemBatch.stallName}</strong>
//           </p>
//           <div className="d-flex justify-content-end gap-2">
//             <Button 
//               variant="outlined" 
//               onClick={handleCancelReplaceCart}
//               className="mr-2"
//             >
//               Cancel
//             </Button>
//             <Button 
//               variant="contained" 
//               color="primary" 
//               onClick={handleConfirmReplaceCart}
//             >
//               Replace Cart
//             </Button>
//           </div>
//         </div>
//       </Dialog>

//       {/* Desktop View */}
//       <div className="deskview pt-5">
//         <Card style={{ width: "350px", height: "250px" }} className="d-flex flex-column justify-content-between py-3 px-2">
//           <div className="row">
//             <div className="col-6 text-center py-2 pointer" onClick={() => openImages(props.item.stallitem)}>
//               {!props.item.stalltemBatch.imageUrl && <img src={dummyImage} alt="Item" width="150" height="150" className="itemimage"></img>}
//               {props.item.stalltemBatch.imageUrl && <img src={props.item.stalltemBatch.imageUrl} alt="Item" width="150" height="150" className="itemimage"></img>}
//             </div>
//             <div className="col-6 text-right pt-3">
//               <div className="row justify-content-end mr-3">
//                 <div className="font-24"><b>
//                   <FxCurrency value={props.item.stalltemBatch.price} />
//                   {props.item.stalltemBatch.listingPrice > 0 && (
//                     <div className="font-14 text-muted text-decoration-line-through">
//                       <FxCurrency value={props.item.stalltemBatch.listingPrice} />
//                     </div>
//                   )}
//                   </b></div>
//                 {props.item.stalltemBatch.unit && <div className="font-15 pt-2 itemunit-style">/{props.item.stalltemBatch.unit}</div>}
//               </div>
//               <div className="row justify-content-end mr-3 pt-3">
//                 {props.item.stalltemBatch && !props.item.stalltemBatch.isCustomized &&
//                   <div className="d-flex align-items-center justify-content-between b" style={{ width: 80, height: 29 }}>
//                     <span className={`count-minus pointer color-primary h-100 d-flex align-items-center justify-content-center ${atMin ? 'opacity-50 pointer-events-none' : ''}`}
//                       onClick={() => reduceQtyFromCart(batch, deliveryTime, deliveryTimeUnits)}
//                       style={{ flex: 1 }}
//                     >
//                       <i className="fas fa-minus-square"></i>
//                     </span>

//                     <span className="quantity-count bl br d-flex align-items-center justify-content-center h-100 m-0 pointer"
//                       style={{ flex: 1 }}>
//                         {qty}
//                     </span>

//                     <span
//                       className={`count-plus pointer color-primary h-100 d-flex align-items-center justify-content-center ${atMax ? 'opacity-50 pointer-events-none' : ''}`}
//                       onClick={() => addQtyToCart(batch, deliveryTime, deliveryTimeUnits)}
//                       style={{ flex: 1 }}
//                     >
//                       <i className="fas fa-plus-square"></i>
//                     </span>
//                   </div>
//                 }
//                 {deliveryTime > 0 && (
//                   <div className="pl-2 pt-2 d-flex align-items-center font-14">
//                     <i className="fas fa-truck mr-2 "></i>
//                     Includes: Est. Prep in {deliveryTime}{" "}
//                     {deliveryTimeUnits === 1 && "Minute(s)"}
//                     {deliveryTimeUnits === 2 && "Hour(s)"}
//                     {deliveryTimeUnits === 3 && "Day(s)"}
//                   </div>
//                 )}
//                 {props.item.stalltemBatch && props.item.stalltemBatch.isCustomized &&
//                   <span>
//                     <Button size="small" variant="contained" color="primary" className={`outline-none ${atMax ? 'opacity-50 pointer-events-none' : ''}`}
//                       onClick={() => openCustomizeForm(props.item.stalltemBatch)}
//                       aria-disabled={atMax}
//                       title={atMax ? `Max ${maxLimit} reached` : 'Add'}>
//                         Add
//                     </Button>
//                   </span>
//                 }
//               </div>
//             </div>
//           </div>
//           <div>
//             <span className='pl-2 font-22 itemname-style'>{props.item.stalltemBatch.itemName}</span>
//             {props.item.stalltemBatch.stallItemDescription && <span className='info-placement pl-1 zoom-in-out-box'>
//               <FxPopup image={info} maxWidth="370px" fontSize="12px">
//                 <div className='p-3'>
//                   {props.item.stalltemBatch.stallItemDescription}
//                 </div>
//               </FxPopup>
//             </span>}
//           </div>
//           <div className="row pl-4">
//             {
//               props.item.stallItemTags && props.item.stallItemTags.length > 0 && props.item.stallItemTags.map((tag: any, i: number) => (
//                 <div className="pr-2" key={i}>
//                   <div className="tagname-style font-12 px-1 py-0">
//                     {tag.itemTagName}
//                   </div>
//                 </div>
//               ))
//             }
//           </div>
//         </Card>
//       </div>

//       {/* Tablet View */}
//       <div className="tabview pt-5">
//         <Card style={{ height: "150px" }} className="d-flex flex-column justify-content-between py-3 px-2">
//           <div className="row">
//             <div className="col-3 text-center py-2">
//               <div className='pointer' onClick={() => openImages(props.item.stallitem)}>
//                 {!props.item.stalltemBatch.imageUrl && <img src={dummyImage} alt="Item" width="120" height="120" className="itemimage"></img>}
//                 {props.item.stalltemBatch.imageUrl && <img src={props.item.stalltemBatch.imageUrl} alt="Item" width="120" height="120" className="itemimage"></img>}
//               </div>
//               <div className="col-12 text-center pl-4 mt-n4">
//                 {props.item.stalltemBatch && !props.item.stalltemBatch.isCustomized &&
//                   <div className="d-flex align-items-center justify-content-between b" style={{ width: 80, height: 29, backgroundColor: "#f69516", borderRadius: "4px" }}>
//                     <span
//                       className={`count-minus pointer color-white h-100 d-flex align-items-center justify-content-center ${atMin ? 'opacity-50 pointer-events-none' : ''}`}
//                       onClick={() => reduceQtyFromCart(batch, deliveryTime, deliveryTimeUnits)}
//                       style={{ flex: 1 }}
//                     >
//                       <i className="fas fa-minus-square font-20"></i>
//                     </span>
//                     <span className="quantity-count bl br d-flex align-items-center justify-content-center h-100 m-0 pointer color-white"
//                       style={{ flex: 1 }}><b>{qty}</b></span>
//                     <span
//                       className={`count-plus pointer color-white h-100 d-flex align-items-center justify-content-center ${atMax ? 'opacity-50 pointer-events-none' : ''}`}
//                       onClick={() => addQtyToCart(batch, deliveryTime, deliveryTimeUnits)}
//                       style={{ flex: 1 }}
//                     >
//                       <i className="fas fa-plus-square font-20"></i>
//                     </span>
//                   </div>
//                 }
//                 {deliveryTime > 0 && (
//                   <div className="pl-2 pt-2 d-flex align-items-center font-14">
//                     <i className="fas fa-truck mr-2 text-primary"></i>
//                     Est. Delivery in {deliveryTime}{" "}
//                     {deliveryTimeUnits === 1 && "Minute(s)"}
//                     {deliveryTimeUnits === 2 && "Hour(s)"}
//                     {deliveryTimeUnits === 3 && "Day(s)"}
//                   </div>
//                 )}
//                 {props.item.stalltemBatch && props.item.stalltemBatch.isCustomized &&
//                   <span>
//                     <Button size="small" variant="contained" color="primary" className="outline-none"
//                       onClick={() => openCustomizeForm(props.item.stalltemBatch)}>Add</Button>
//                   </span>
//                 }
//               </div>
//             </div>
//             <div className="col-9 pt-1 pl-5">
//               <div>
//                 <span className='pl-2 font-22 itemname-style'>{props.item.stalltemBatch.itemName}</span>
//                 {props.item.stalltemBatch.stallItemDescription && <span className='info-placement pl-1 zoom-in-out-box'>
//                   <FxPopup image={info} maxWidth="370px" fontSize="12px">
//                     <div className='p-3'>
//                       {props.item.stalltemBatch.stallItemDescription}
//                     </div>
//                   </FxPopup>
//                 </span>}
//               </div>
//               <div className="row pl-4 py-1">
//                 {
//                   props.item.stallItemTags && props.item.stallItemTags.length > 0 && props.item.stallItemTags.map((tag: any, i: number) => (
//                     <div className="pr-2" key={i}>
//                       <div className="tagname-style font-14 px-1 py-0">
//                         {tag.itemTagName}
//                       </div>
//                     </div>
//                   ))
//                 }
//               </div>
//               <div className="pl-2">
//                 <span className="font-18"><b><FxCurrency value={props.item.stalltemBatch.price} />
//                 {props.item.stalltemBatch.listingPrice > 0 && (
//                     <div className="font-14 text-muted text-decoration-line-through">
//                       <FxCurrency value={props.item.stalltemBatch.listingPrice} />
//                     </div>
//                   )}</b></span>
//                 {props.item.stalltemBatch.unit && <span className="font-12 itemunit-style">/{props.item.stalltemBatch.unit}</span>}
//               </div>
//             </div>
//           </div>
//         </Card>
//       </div>

//       {/* Mobile View */}
//       <div className="mobileview pt-2">
//         <Card style={{ height: "150px" }} className="d-flex flex-column justify-content-between py-2 px-2">
//           <div className="row">
//             <div className="col-4 text-center py-1">
//               <div className='pointer' onClick={() => openImages(props.item.stallitem)}>
//                 {!props.item.stalltemBatch.imageUrl && <img src={dummyImage} alt="Item" width="100" height="100" className="itemimage"></img>}
//                 {props.item.stalltemBatch.imageUrl && <img src={props.item.stalltemBatch.imageUrl} alt="Item" width="100" height="100" className="itemimage"></img>}
//               </div>
//               <div className="col-12 text-center mt-1">
//                 {props.item.stalltemBatch && !props.item.stalltemBatch.isCustomized &&
//                   <div className="d-flex align-items-center justify-content-between" style={{ width: 70, height: 29, backgroundColor: "#f69516", borderRadius: "4px" }}>
//                     <span
//                       className={`count-minus pointer color-white h-100 d-flex align-items-center justify-content-center ${atMin ? 'opacity-50 pointer-events-none' : ''}`}
//                       onClick={() => reduceQtyFromCart(batch, deliveryTime, deliveryTimeUnits)}
//                       style={{ flex: 1 }}
//                     >
//                       <i className="fas fa-minus-square font-18"></i>
//                     </span>
//                     <span className="quantity-count bl br d-flex align-items-center justify-content-center h-100 m-0 pointer color-white"
//                       style={{ flex: 1 }}><b>{qty}</b></span>
//                     <span
//                       className={`count-plus pointer color-white h-100 d-flex align-items-center justify-content-center ${atMax ? 'opacity-50 pointer-events-none' : ''}`}
//                       onClick={() => addQtyToCart(batch, deliveryTime, deliveryTimeUnits)}
//                       style={{ flex: 1 }}
//                     >
//                       <i className="fas fa-plus-square font-18"></i>
//                     </span>
//                   </div>
//                 }
//                 {deliveryTime > 0 && (
//                   <div className="pl-2 pt-2 d-flex align-items-center font-14">
//                     <i className="fas fa-truck mr-2 text-primary"></i>
//                     Est. Delivery in {deliveryTime}{" "}
//                     {deliveryTimeUnits === 1 && "Minute(s)"}
//                     {deliveryTimeUnits === 2 && "Hour(s)"}
//                     {deliveryTimeUnits === 3 && "Day(s)"}
//                   </div>
//                 )}
//                 {props.item.stalltemBatch && props.item.stalltemBatch.isCustomized &&
//                   <span className='pl-1'>
//                     <Button size="small" variant="contained" color="primary" className="outline-none"
//                       onClick={() => openCustomizeForm(props.item.stalltemBatch)}>Add</Button>
//                   </span>
//                 }
//               </div>
//             </div>
//             <div className="col-8 pt-2 pl-0">
//               <div>
//                 <span className='pl-2 font-20 itemname-style'>{props.item.stalltemBatch.itemName}</span>
//                 {props.item.stalltemBatch.stallItemDescription && <span className='info-placement pl-1 zoom-in-out-box'>
//                   <FxPopup image={info} maxWidth="370px" fontSize="12px">
//                     <div className='p-3'>
//                       {props.item.stalltemBatch.stallItemDescription}
//                     </div>
//                   </FxPopup>
//                 </span>}
//               </div>              
//               <div className="row pl-4 py-1">
//                 {
//                   props.item.stallItemTags && props.item.stallItemTags.length > 0 && props.item.stallItemTags.map((tag: any, i: number) => (
//                     <div className="pr-2" key={i}>
//                       <div className="tagname-style font-12 px-1 py-0">
//                         {tag.itemTagName}
//                       </div>
//                     </div>
//                   ))
//                 }
//               </div>
//               <div className="pl-2">
//                 <span className="font-16"><b><FxCurrency value={props.item.stalltemBatch.price} />
//                 {props.item.stalltemBatch.listingPrice > 0 && (
//                     <div className="font-14 text-muted text-decoration-line-through">
//                       <FxCurrency value={props.item.stalltemBatch.listingPrice} />
//                     </div>
//                   )}</b></span>
//                 {props.item.stalltemBatch.unit && <span className="font-12 itemunit-style">/{props.item.stalltemBatch.unit}</span>}
//               </div>
//             </div>
//           </div>
//         </Card>
//       </div>
      
//       <Drawer anchor={"right"} open={registerComponentFormOpen} onClose={handleRegisterComponentForm}>
//         <RegisterComponent stallId={props.stallId} handleRegisterComponentForm={handleRegisterComponentForm} />
//       </Drawer>
//       <Drawer anchor={"right"} classes={{ paper: classes.drawerWidth }} open={customizeFormOpen} onClose={closeCustomizeForm}>
//         <CustomizeForm stallItemBatchId={stallItemBatchId} stallItemId={stallItemId}
//           handleCustomizedDetails={handleCustomizedDetails} closeCustomizeForm={closeCustomizeForm} />
//       </Drawer>
//       <Dialog
//         open={imageSlideOpen}
//         onClose={handleImageSlideClose}
//         aria-labelledby="alert-dialog-title"
//         aria-describedby="alert-dialog-description">
//         <ImageSlides imageConfig={imageConfig} handleImageSlideClose={handleImageSlideClose} />
//       </Dialog>      
//       <Dialog
//         open={qtyAlertOpen}
//         maxWidth="sm"
//         fullWidth
//         onClose={handleQtyAlertClose}
//         aria-labelledby="stallitem-qty-alert-title"
//         aria-describedby="stallitem-qty-alert-desc"
//       >
//         <ItemCustomizeAlert
//           errorMessages={qtyAlertMessage}
//           handleClose={handleQtyAlertClose}
//         />
//       </Dialog>
//     </div>
//   );
// };

// export default StallItem;

import React, { useEffect, useState } from 'react';
import './StallItem.scss';
import Card from '@material-ui/core/Card';
import dummyImage from "./../../../assets/images/dummy.png";
import { AlertService, FxCurrency, FxPopup } from '../../fx-core';
import { Button, makeStyles, Dialog, DialogTitle, DialogContent, DialogActions, Checkbox, TextField, FormControlLabel } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import RegisterComponent from '../../RegisterComponent/RegisterComponent';
import { useDispatch, useSelector } from 'react-redux';
import CustomizeForm from '../CustomizeForm/CustomizeForm';
import * as _ from 'lodash';
import info from "../../../assets/info.png";
import ImageSlides from '../../general/ImageSlides/ImageSlides';
// add this import near the others
import ItemCustomizeAlert from '../ItemCustomizeAlert/ItemCustomizeAlert';
import { http, localstorage } from '../../fx-core';

const DEFAULT_COMMISSION_PERCENT = 5;
const styles = makeStyles((theme) => ({
  drawerWidth: {
    [theme.breakpoints.down(599)]: {
      width: '90%'
    },
    [theme.breakpoints.up(600)]: {
      width: '70%'
    },
    [theme.breakpoints.up(1025)]: {
      width: '35%'
    }
  }
}));

const StallItem = (props: any) => {
  const classes = styles();
  const dispatch = useDispatch();
  const cartInfo = useSelector<any, any>(store => store.cart);
  const cart = cartInfo;
  const listingCartData = useSelector<any, any>(s => s.listingCart);
  const [registerComponentFormOpen, setRegisterComponentFormOpen] = useState(false);
  const [customizeFormOpen, setCustomizeFormOpen] = useState(false);
  const [stallItemBatchId, setStallItemBatchId] = useState(0);
  const [stallItemId, setStallItemId] = useState(0);
  const [imageSlideOpen, setImageSlideOpen] = useState(false);
  const [imageConfig, setImageConfig] = useState({});  
  const [deliveryTime, setDeliveryTime] = useState(props.item.stallitem.deliveryTime);
  const [deliveryTimeUnits, setDeliveryTimeUnits] = useState(props.item.stallitem.deliveryTimeUnits);
  console.log("deliveryTimeUnits", deliveryTime, deliveryTimeUnits);

  // Alert dialog for quantity rules
  const [qtyAlertOpen, setQtyAlertOpen] = useState(false);
  const [qtyAlertMessage, setQtyAlertMessage] = useState<any[]>([]);

  // Cart replacement confirmation
  const [showCartReplaceConfirm, setShowCartReplaceConfirm] = useState(false);
  const [pendingCartAction, setPendingCartAction] = useState<any>(null);
  const [currentStallName, setCurrentStallName] = useState('');
  const [newStallName, setNewStallName] = useState('');

  //promote item states
const [promoteDialogOpen, setPromoteDialogOpen] = useState(false);
const [commissionChoice, setCommissionChoice] = useState<'default' | 'custom'>('default');
const [customCommission, setCustomCommission] = useState('');
const isAffiliateEligible = !!props.item.stalltemBatch?.isAffiliateEnabled;
const merchantMargin = Number(props.item.stalltemBatch?.marginNumber) || 0;
const [isPromoted, setIsPromoted] = useState(false); // "Promoted" = reseller has submitted, separate from merchant's affiliate flag
const [promoteSubmitting, setPromoteSubmitting] = useState(false);
const currentUserId = parseInt(localstorage.getItem("userId") || "0");
const isOwnProduct = !!props.stallOwnerId && props.stallOwnerId === currentUserId;
  const handleRegisterComponentForm = () => {
    setRegisterComponentFormOpen(false);
  };

  const openRegisterComponentFormOpen = () => {
    setRegisterComponentFormOpen(true);
  };

  const openStallLinkUrl = (prod: any) => {
    window.open(props.stallLinkUrl, '_blank');
  };
  // ---- Promote & Earn handlers ----
  const openPromoteDialog = (event: any) => {
    event.stopPropagation();
    setCommissionChoice('default');
    setCustomCommission('');
    setPromoteDialogOpen(true);
  };

  const closePromoteDialog = () => {
    setPromoteDialogOpen(false);
  };

  const handleCommissionChoiceChange = (choice: 'default' | 'custom') => {
    setCommissionChoice(choice);
  };

  const handleCustomCommissionChange = (e: any) => {
    setCustomCommission(e.target.value);
  };

  const submitPromotion = () => {
    const marginValue = commissionChoice === 'default'
  ? merchantMargin
  : Number(customCommission);

        if (commissionChoice === 'custom' && (!customCommission || isNaN(marginValue) || marginValue <= 0)) {
      showWarn('Please enter a valid commission percentage.', 'Promotion');
      return;
    }
    
    setPromoteSubmitting(true);
    const payload = [{
  ResellerId: parseInt(localstorage.getItem("userId") || "0"),
  MerchantId: props.stallOwnerId || 0,
  MerchantStallId: props.stallId,
  ResellerStallId: 0,
  ItemId: batch.stallItemId || batch.id,
  ItemName: batch.itemName,
  MarginNumber: marginValue
}];

    let apiOptions: any = {
      url: 'affiliate-product/addAffiliateProduct',
      data: payload
    };
        http.post(apiOptions).then(() => {
      setIsPromoted(true);
      setPromoteSubmitting(false);
      setPromoteDialogOpen(false);
            }).catch((err) => {
      console.error('Promotion submit failed:', err);
      setPromoteSubmitting(false);
      // The app's http wrapper already surfaces the server's error message as a toast
      // (that's the "You cannot promote your own product." message you're seeing) —
      // no need to show a second one here.
    });
  };

  // Replace renderPromoteControl() entirely with:
const renderPromoteControl = () => {
  if (!isAffiliateEligible) {
    return null; // merchant hasn't enabled affiliate on this item — show nothing
  }
  if (isOwnProduct) {
    return (
      <span
        className="font-12 px-2 py-1"
        title="You cannot promote your own product"
        style={{ color: '#9e9e9e', fontWeight: 600, whiteSpace: 'nowrap' }}
      >
        <i className="fas fa-ban mr-1"></i>Do not promote your own product
      </span>
    );
  }
  if (isPromoted) {
    return (
      <span className="promoted-badge font-12 px-2 py-1" title="Already submitted for affiliate promotion">
        <i className="fas fa-bullhorn mr-1"></i>Promoted
      </span>
    );
  }
  return (
    <span className="promote-icon pointer" onClick={openPromoteDialog} title="Promote & Earn">
      <i className="fas fa-bullhorn"></i>
    </span>
  );
};

  // Check if adding item from different stall
  const isDifferentStall = () => {
    return cartInfo.stallId > 0 && props.stallId !== cartInfo.stallId && cartInfo.items.length > 0;
  };

  // Show cart replacement confirmation
  const showCartReplaceConfirmation = (actionType: string, item: any, stallName: string) => {
    setPendingCartAction({ actionType, item });
    setCurrentStallName(cartInfo.stallName || 'Current Stall');
    setNewStallName(stallName || props.item.stalltemBatch.stallName || 'New Stall');
    setShowCartReplaceConfirm(true);
  };

  // Handle confirmation to replace cart
  const handleConfirmReplaceCart = () => {
    if (pendingCartAction) {
      const { actionType, item } = pendingCartAction;
      
      // Clear current cart and add new item
      dispatch({ type: "CLEAR_CART", payload: {} });
      
      if (actionType === 'add') {
        // For add action with min quantity logic
        const maxLimit = getEffectiveMax(item);
        const minLimit = getMinLimit(item);
        const currentQty = 0; // Starting fresh

        if (currentQty === 0 && typeof minLimit === 'number' && minLimit > 1) {
          const target = typeof maxLimit === 'number' ? Math.min(minLimit, maxLimit) : minLimit;
          for (let i = 0; i < target; i++) {
            dispatch({
              type: "ADD_CART",
              payload: { 
                stallId: props.stallId, 
                stallName: props.stallName || props.item.stalltemBatch.stallName,
                item: { 
                  ...item, 
                  isTreasureHunt: props.item.stallitem?.isTreasureHunt || 0,
                  deliveryTime: deliveryTime || 0,
                  deliveryTimeUnits: deliveryTimeUnits || 1
                }
              }
            });
          }
        } else {
          // Normal add
          dispatch({
            type: "ADD_CART",
            payload: { 
              stallId: props.stallId, 
              stallName: props.stallName || props.item.stalltemBatch.stallName,
              item: { 
                ...item, 
                isTreasureHunt: props.item.stallitem?.isTreasureHunt || 0,
                deliveryTime: deliveryTime || 0,
                deliveryTimeUnits: deliveryTimeUnits || 1
              }
            }
          });
        }
      } else if (actionType === 'customize') {
        // Handle customization
        setStallItemBatchId(item.id);
        setStallItemId(item.stallItemId);
        setCustomizeFormOpen(true);
      }
    }
    setShowCartReplaceConfirm(false);
    setPendingCartAction(null);
  };

  // Handle cancel cart replacement
  const handleCancelReplaceCart = () => {
    setShowCartReplaceConfirm(false);
    setPendingCartAction(null);
  };

  const reduceQtyFromCart = (item: any, deliveryTimeParam = deliveryTime, deliveryTimeUnitsParam = deliveryTimeUnits) => {
    getModifierAmount(item);

    const minLimit = getMinLimit(item);
    const currentQty = getCartQty(item);
    const nextQty = currentQty - 1;

    if (typeof minLimit === 'number' && nextQty < minLimit) {
      return;
    }

    dispatch({ 
      type: "REDUCE_CART", 
      payload: { 
        stallId: props.stallId, 
        item, 
        deliveryTime: deliveryTimeParam || 0,
        deliveryTimeUnits: deliveryTimeUnitsParam || 1
      } 
    });
  };

  const addQtyToCart = (item: any, deliveryTimeParam = deliveryTime, deliveryTimeUnitsParam = deliveryTimeUnits) => {
    console.log("addQtyToCart", item, deliveryTimeParam, deliveryTimeUnitsParam);
    getModifierAmount(item);

    // Check if different stall and show confirmation
    if (isDifferentStall()) {
      showCartReplaceConfirmation('add', item, props.stallName || props.item.stalltemBatch.stallName);
      return;
    }

    const maxLimit = getEffectiveMax(item);
    const minLimit = getMinLimit(item);
    const currentQty = getCartQty(item);

    // Already capped?
    if (typeof maxLimit === 'number' && currentQty >= maxLimit) {
      showWarn(`You can't add more than ${maxLimit} for this item.`);
      return;
    }

    // First add and min > 1: jump to min (but don't exceed max/stock)
    if (currentQty === 0 && typeof minLimit === 'number' && minLimit > 1) {
      const target = typeof maxLimit === 'number' ? Math.min(minLimit, maxLimit) : minLimit;

      if (listingCartData.cartCount > 0) {
        dispatch({ type: "CLEAR_LISTING_CART", payload: {} });
      }
      for (let i = 0; i < target; i++) {
        dispatch({
          type: "ADD_CART",
          payload: { 
            stallId: props.stallId, 
            stallName: props.stallName || props.item.stalltemBatch.stallName,
            item: { 
              ...item, 
              isTreasureHunt: props.item.stallitem?.isTreasureHunt || 0,
              deliveryTime: deliveryTimeParam || 0,
              deliveryTimeUnits: deliveryTimeUnitsParam || 1
            }
          }
        });
      }
      return;
    }

    // Normal +1 with cap
    const nextQty = currentQty + 1;
    if (typeof maxLimit === 'number' && nextQty > maxLimit) {
      showWarn(`You can't add more than ${maxLimit} for this item.`);
      return;
    }

    if (listingCartData.cartCount > 0) {
      dispatch({ type: "CLEAR_LISTING_CART", payload: {} });
    }
    dispatch({
      type: "ADD_CART",
      payload: { 
        stallId: props.stallId, 
        stallName: props.stallName || props.item.stalltemBatch.stallName,
        item: { 
          ...item, 
          isTreasureHunt: props.item.stallitem?.isTreasureHunt || 0,
          deliveryTime: deliveryTimeParam || 0,
          deliveryTimeUnits: deliveryTimeUnitsParam || 1
        }
      }
    });
  };

  const getModifierAmount = (item: any) => {
    if (item.customizedDetails && item.customizedDetails.length > 0) {
      let totalModifierAmt = _.sumBy(item.customizedDetails, 'stallItemCustomizeDetailPrice');
      item.modifierAmt = totalModifierAmt;
    }
  };

  const openCustomizeForm = (item: any) => {
    // Check if different stall and show confirmation
    if (isDifferentStall()) {
      showCartReplaceConfirmation('customize', item, props.stallName);
      return;
    }

    const maxLimit = getEffectiveMax(item);
    const currentQty = Number(item?.quantity ?? 0);
    if (typeof maxLimit === 'number' && currentQty >= maxLimit) {
      showWarn(`You can't add more than ${maxLimit} for this item.`);
      return;
    }
    setStallItemBatchId(item.id);
    setStallItemId(item.stallItemId);
    setCustomizeFormOpen(true);
  };

  const closeCustomizeForm = () => {
    setCustomizeFormOpen(false);
  };

  const handleCustomizedDetails = (data: any, id: any) => {
    setCustomizeFormOpen(false);
    props.handleStallItemCustomized(data, id, deliveryTime, deliveryTimeUnits);
  };

  const openImages = (item: any) => {
    let config = {
      api: `portal/stallitem/${item.id}/images`,
      title: item.title
    };
    setImageConfig(config);
    setImageSlideOpen(true);
  };

  const handleImageSlideClose = () => {
    setImageSlideOpen(false);
  };

  const getMaxLimit = (item: any): number | undefined => {
    const max = Number(item?.maximumQuantity);
    return Number.isFinite(max) && max > 0 ? max : undefined;
  };

  const getMinLimit = (item: any): number | undefined => {
    const min = Number(item?.minimumQuantity);
    return Number.isFinite(min) && min >= 0 ? min : undefined;
  };

  // If you also want to cap by available stock:
  const getEffectiveMax = (item: any): number | undefined => {
    const maxLimit = getMaxLimit(item);
    const stock = Number(item?.currentQuantity);
    const stockCap = Number.isFinite(stock) && stock > 0 ? stock : undefined;
    if (typeof maxLimit === 'number' && typeof stockCap === 'number') return Math.min(maxLimit, stockCap);
    return (typeof maxLimit === 'number') ? maxLimit : stockCap;
  };

  // keep the SAME name:
  const showWarn = (
    msgOrList: string | { groupName: string; message: string }[],
    groupName: string = 'Quantity'
  ) => {
    if (Array.isArray(msgOrList)) {
      setQtyAlertMessage(msgOrList);
    } else {
      setQtyAlertMessage([{ groupName, message: msgOrList }]);
      if ((AlertService as any)?.warn) (AlertService as any).warn(msgOrList);
    }
    setQtyAlertOpen(true);
  };

  // Try to resolve the same line items in cart that match this batch
  const getCartQty = (batch: any): number => {
    const sid = props.stallId;
    const batchId = batch?.id;
    const stallItemId = batch?.stallItemId;

    const root = cartInfo || {};
    const lines =
      Array.isArray(root.items) ? root.items :
      Array.isArray(root) ? root :
      Array.isArray(root?.[sid]?.items) ? root[sid].items :
      [];

    return lines
      .filter((l: any) =>
        (l?.id ?? l?.stallItemBatchId) === batchId || l?.stallItemId === stallItemId
      )
      .reduce((sum: number, l: any) => sum + Number(l?.quantity ?? 0), 0);
  };

  const openQtyAlert = () => setQtyAlertOpen(true);
  
  const handleQtyAlertClose = () => {
    setQtyAlertOpen(false);
    setQtyAlertMessage([]);
  };

  const batch = props.item.stalltemBatch;
  const maxLimit = getEffectiveMax(batch);
  const minLimit = getMinLimit(batch);
  const qty = getCartQty(batch);

  const atMax = typeof maxLimit === 'number' && qty >= maxLimit;
  const atMin = typeof minLimit === 'number' && qty <= minLimit;

  useEffect(() => {
    setDeliveryTime(props.item.stallitem.deliveryTime);
    setDeliveryTimeUnits(props.item.stallitem.deliveryTimeUnits);
  }, [props.item.stallitem.deliveryTime, props.item.stallitem.deliveryTimeUnits]);

  return (
    <div className="stallitem-ui">
      {/* cart replacement confirmation dialog */}
      <Dialog
        open={showCartReplaceConfirm}
        onClose={handleCancelReplaceCart}
        aria-labelledby="cart-replace-confirm-title"
        aria-describedby="cart-replace-confirm-description"
      >
        <div className="p-4">
          <h4 id="cart-replace-confirm-title" className="mb-3">
            Replace Cart Items?
          </h4>
          <p id="cart-replace-confirm-description" className="mb-4">
            Your cart contains items from <strong>{currentStallName}</strong>. 
            Do you want to replace them with items from <strong>{props.item.stalltemBatch.stallName}</strong>
          </p>
          <div className="d-flex justify-content-end gap-2"> 
            <Button 
              variant="outlined" 
              onClick={handleCancelReplaceCart}
              className="mr-2"
            >
              Cancel
            </Button>
            <Button 
              variant="contained" 
              color="primary" 
              onClick={handleConfirmReplaceCart}
            >
              Replace Cart
            </Button>
          </div>
        </div>
      </Dialog>
      {/* Promote & Earn commission dialog */}
      <Dialog
        open={promoteDialogOpen}
        onClose={closePromoteDialog}
        maxWidth="xs"
        fullWidth
        aria-labelledby="promote-dialog-title"
      >
        <DialogTitle id="promote-dialog-title">Promote &amp; Earn</DialogTitle>
        <DialogContent>
          <div className="pb-2 font-14 text-muted">
            {batch?.itemName}
          </div>
          <FormControlLabel
            control={
              <Checkbox
                checked={commissionChoice === 'default'}
                onChange={() => handleCommissionChoiceChange('default')}
                color="primary"
              />
            }
            label={`Accept existing commission (${merchantMargin}%)`}
          />
          <div>
            <FormControlLabel
              control={
                <Checkbox
                  checked={commissionChoice === 'custom'}
                  onChange={() => handleCommissionChoiceChange('custom')}
                  color="primary"
                />
              }
              label="Propose your own commission"
            />
          </div>
          {commissionChoice === 'custom' && (
            <TextField
              type="number"
              variant="outlined"
              size="small"
              label="Commission %"
              value={customCommission}
              onChange={handleCustomCommissionChange}
              fullWidth
              className="mt-2"
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={closePromoteDialog} disabled={promoteSubmitting}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={submitPromotion}
            disabled={promoteSubmitting}
          >
            {promoteSubmitting ? 'Submitting...' : 'Submit'}
          </Button>
        </DialogActions>
      </Dialog>
{/* Desktop View */}
<div className="deskview pt-5">
  <Card style={{ width: "350px", height: "250px" }} className="d-flex flex-column justify-content-between py-3 px-2">
    <div className="row">
      <div className="col-6 text-center py-2 pointer" onClick={() => openImages(props.item.stallitem)}>
        {!props.item.stalltemBatch.imageUrl && <img src={dummyImage} alt="Item" width="150" height="150" className="itemimage"></img>}
        {props.item.stalltemBatch.imageUrl && <img src={props.item.stalltemBatch.imageUrl} alt="Item" width="150" height="150" className="itemimage"></img>}
      </div>
      <div className="col-6 text-right pt-3">
        <div className="row justify-content-end mr-3">
          <div className="font-24"><b>
            <FxCurrency value={props.item.stalltemBatch.price} />
            {props.item.stalltemBatch.listingPrice > 0 && (
              <div className="font-14 text-muted text-decoration-line-through">
                <FxCurrency value={props.item.stalltemBatch.listingPrice} />
              </div>
            )}
          </b></div>
          {props.item.stalltemBatch.unit && <div className="font-15 pt-2 itemunit-style">/{props.item.stalltemBatch.unit}</div>}
        </div>
        <div className="row justify-content-end mr-3 pt-3">
          {props.item.stalltemBatch && !props.item.stalltemBatch.isCustomized &&
            <div className="d-flex align-items-center justify-content-between b" style={{ width: 80, height: 29 }}>
              <span className={`count-minus pointer color-primary h-100 d-flex align-items-center justify-content-center ${atMin ? 'opacity-50 pointer-events-none' : ''}`}
                onClick={() => reduceQtyFromCart(batch, deliveryTime, deliveryTimeUnits)}
                style={{ flex: 1 }}
              >
                <i className="fas fa-minus-square"></i>
              </span>
              <span className="quantity-count bl br d-flex align-items-center justify-content-center h-100 m-0 pointer"
                style={{ flex: 1 }}>
                {qty}
              </span>
              <span
                className={`count-plus pointer color-primary h-100 d-flex align-items-center justify-content-center ${atMax ? 'opacity-50 pointer-events-none' : ''}`}
                onClick={() => addQtyToCart(batch, deliveryTime, deliveryTimeUnits)}
                style={{ flex: 1 }}
              >
                <i className="fas fa-plus-square"></i>
              </span>
            </div>
          }
          {deliveryTime > 0 && (
            <div className="pl-2 pt-2 d-flex align-items-center font-14">
              <i className="fas fa-truck mr-2"></i>
              Includes: Est. Prep in {deliveryTime}{" "}
              {deliveryTimeUnits === 1 && "Minute(s)"}
              {deliveryTimeUnits === 2 && "Hour(s)"}
              {deliveryTimeUnits === 3 && "Day(s)"}
            </div>
          )}
          {props.item.stalltemBatch && props.item.stalltemBatch.isCustomized &&
            <span>
              <Button size="small" variant="contained" color="primary" className={`outline-none ${atMax ? 'opacity-50 pointer-events-none' : ''}`}
                onClick={() => openCustomizeForm(props.item.stalltemBatch)}
                aria-disabled={atMax}
                title={atMax ? `Max ${maxLimit} reached` : 'Add'}>
                Add
              </Button>
            </span>
          }
        </div>
      </div>
    </div>
    <div className="d-flex align-items-center justify-content-between">
      <div>
        <span className='pl-2 font-22 itemname-style'>{props.item.stalltemBatch.itemName}</span>
        {props.item.stalltemBatch.stallItemDescription && <span className='info-placement pl-1 zoom-in-out-box'>
          <FxPopup image={info} maxWidth="370px" fontSize="12px">
            <div className='p-3'>
              {props.item.stalltemBatch.stallItemDescription}
            </div>
          </FxPopup>
        </span>}
      </div>
      <div className="pr-2">{renderPromoteControl()}</div>
    </div>
    <div className="row pl-4">
      {props.item.stallItemTags && props.item.stallItemTags.length > 0 && props.item.stallItemTags.map((tag: any, i: number) => (
        <div className="pr-2" key={i}>
          <div className="tagname-style font-12 px-1 py-0">
            {tag.itemTagName}
          </div>
        </div>
      ))}
    </div>
  </Card>
</div>

      {/* Tablet View */}
<div className="tabview pt-5">
  <Card style={{ height: "150px" }} className="d-flex flex-column justify-content-between py-3 px-2">
    <div className="row">
      <div className="col-3 text-center py-2">
        <div className='pointer' onClick={() => openImages(props.item.stallitem)}>
          {!props.item.stalltemBatch.imageUrl && <img src={dummyImage} alt="Item" width="120" height="120" className="itemimage"></img>}
          {props.item.stalltemBatch.imageUrl && <img src={props.item.stalltemBatch.imageUrl} alt="Item" width="120" height="120" className="itemimage"></img>}
        </div>
        <div className="col-12 text-center pl-4 mt-n4">
          {props.item.stalltemBatch && !props.item.stalltemBatch.isCustomized &&
            <div className="d-flex align-items-center justify-content-between b" style={{ width: 80, height: 29, backgroundColor: "#f69516", borderRadius: "4px" }}>
              <span
                className={`count-minus pointer color-white h-100 d-flex align-items-center justify-content-center ${atMin ? 'opacity-50 pointer-events-none' : ''}`}
                onClick={() => reduceQtyFromCart(batch, deliveryTime, deliveryTimeUnits)}
                style={{ flex: 1 }}
              >
                <i className="fas fa-minus-square font-20"></i>
              </span>
              <span className="quantity-count bl br d-flex align-items-center justify-content-center h-100 m-0 pointer color-white"
                style={{ flex: 1 }}><b>{qty}</b></span>
              <span
                className={`count-plus pointer color-white h-100 d-flex align-items-center justify-content-center ${atMax ? 'opacity-50 pointer-events-none' : ''}`}
                onClick={() => addQtyToCart(batch, deliveryTime, deliveryTimeUnits)}
                style={{ flex: 1 }}
              >
                <i className="fas fa-plus-square font-20"></i>
              </span>
            </div>
          }
          {deliveryTime > 0 && (
            <div className="pl-2 pt-2 d-flex align-items-center font-14">
              <i className="fas fa-truck mr-2 text-primary"></i>
              Est. Delivery in {deliveryTime}{" "}
              {deliveryTimeUnits === 1 && "Minute(s)"}
              {deliveryTimeUnits === 2 && "Hour(s)"}
              {deliveryTimeUnits === 3 && "Day(s)"}
            </div>
          )}
          {props.item.stalltemBatch && props.item.stalltemBatch.isCustomized &&
            <span>
              <Button size="small" variant="contained" color="primary" className="outline-none"
                onClick={() => openCustomizeForm(props.item.stalltemBatch)}>Add</Button>
            </span>
          }
        </div>
      </div>
      <div className="col-9 pt-1 pl-5">
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <span className='pl-2 font-22 itemname-style'>{props.item.stalltemBatch.itemName}</span>
            {props.item.stalltemBatch.stallItemDescription && <span className='info-placement pl-1 zoom-in-out-box'>
              <FxPopup image={info} maxWidth="370px" fontSize="12px">
                <div className='p-3'>
                  {props.item.stalltemBatch.stallItemDescription}
                </div>
              </FxPopup>
            </span>}
          </div>
          <div className="pr-2">{renderPromoteControl()}</div>
        </div>
        <div className="row pl-4 py-1">
          {
            props.item.stallItemTags && props.item.stallItemTags.length > 0 && props.item.stallItemTags.map((tag: any, i: number) => (
              <div className="pr-2" key={i}>
                <div className="tagname-style font-14 px-1 py-0">
                  {tag.itemTagName}
                </div>
              </div>
            ))
          }
        </div>
        <div className="pl-2">
          <span className="font-18"><b><FxCurrency value={props.item.stalltemBatch.price} />
          {props.item.stalltemBatch.listingPrice > 0 && (
              <div className="font-14 text-muted text-decoration-line-through">
                <FxCurrency value={props.item.stalltemBatch.listingPrice} />
              </div>
            )}</b></span>
          {props.item.stalltemBatch.unit && <span className="font-12 itemunit-style">/{props.item.stalltemBatch.unit}</span>}
        </div>
      </div>
    </div>
  </Card>
</div>

      {/* Mobile View */}
<div className="mobileview pt-2">
  <Card style={{ height: "150px" }} className="d-flex flex-column justify-content-between py-2 px-2">
    <div className="row">
      <div className="col-4 text-center py-1">
        <div className='pointer' onClick={() => openImages(props.item.stallitem)}>
          {!props.item.stalltemBatch.imageUrl && <img src={dummyImage} alt="Item" width="100" height="100" className="itemimage"></img>}
          {props.item.stalltemBatch.imageUrl && <img src={props.item.stalltemBatch.imageUrl} alt="Item" width="100" height="100" className="itemimage"></img>}
        </div>
        <div className="col-12 text-center mt-1">
          {props.item.stalltemBatch && !props.item.stalltemBatch.isCustomized &&
            <div className="d-flex align-items-center justify-content-between" style={{ width: 70, height: 29, backgroundColor: "#f69516", borderRadius: "4px" }}>
              <span
                className={`count-minus pointer color-white h-100 d-flex align-items-center justify-content-center ${atMin ? 'opacity-50 pointer-events-none' : ''}`}
                onClick={() => reduceQtyFromCart(batch, deliveryTime, deliveryTimeUnits)}
                style={{ flex: 1 }}
              >
                <i className="fas fa-minus-square font-18"></i>
              </span>
              <span className="quantity-count bl br d-flex align-items-center justify-content-center h-100 m-0 pointer color-white"
                style={{ flex: 1 }}><b>{qty}</b></span>
              <span
                className={`count-plus pointer color-white h-100 d-flex align-items-center justify-content-center ${atMax ? 'opacity-50 pointer-events-none' : ''}`}
                onClick={() => addQtyToCart(batch, deliveryTime, deliveryTimeUnits)}
                style={{ flex: 1 }}
              >
                <i className="fas fa-plus-square font-18"></i>
              </span>
            </div>
          }
          {deliveryTime > 0 && (
            <div className="pl-2 pt-2 d-flex align-items-center font-14">
              <i className="fas fa-truck mr-2 text-primary"></i>
              Est. Delivery in {deliveryTime}{" "}
              {deliveryTimeUnits === 1 && "Minute(s)"}
              {deliveryTimeUnits === 2 && "Hour(s)"}
              {deliveryTimeUnits === 3 && "Day(s)"}
            </div>
          )}
          {props.item.stalltemBatch && props.item.stalltemBatch.isCustomized &&
            <span className='pl-1'>
              <Button size="small" variant="contained" color="primary" className="outline-none"
                onClick={() => openCustomizeForm(props.item.stalltemBatch)}>Add</Button>
            </span>
          }
        </div>
      </div>
      <div className="col-8 pt-2 pl-0">
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <span className='pl-2 font-20 itemname-style'>{props.item.stalltemBatch.itemName}</span>
            {props.item.stalltemBatch.stallItemDescription && <span className='info-placement pl-1 zoom-in-out-box'>
              <FxPopup image={info} maxWidth="370px" fontSize="12px">
                <div className='p-3'>
                  {props.item.stalltemBatch.stallItemDescription}
                </div>
              </FxPopup>
            </span>}
          </div>
          <div className="pr-2">{renderPromoteControl()}</div>
        </div>             
        <div className="row pl-4 py-1">
          {
            props.item.stallItemTags && props.item.stallItemTags.length > 0 && props.item.stallItemTags.map((tag: any, i: number) => (
              <div className="pr-2" key={i}>
                <div className="tagname-style font-12 px-1 py-0">
                  {tag.itemTagName}
                </div>
              </div>
            ))
          }
        </div>
        <div className="pl-2">
          <span className="font-16"><b><FxCurrency value={props.item.stalltemBatch.price} />
          {props.item.stalltemBatch.listingPrice > 0 && (
              <div className="font-14 text-muted text-decoration-line-through">
                <FxCurrency value={props.item.stalltemBatch.listingPrice} />
              </div>
            )}</b></span>
          {props.item.stalltemBatch.unit && <span className="font-12 itemunit-style">/{props.item.stalltemBatch.unit}</span>}
        </div>
      </div>
    </div>
  </Card>
</div>
      
      <Drawer anchor={"right"} open={registerComponentFormOpen} onClose={handleRegisterComponentForm}>
        <RegisterComponent stallId={props.stallId} handleRegisterComponentForm={handleRegisterComponentForm} />
      </Drawer>
      <Drawer anchor={"right"} classes={{ paper: classes.drawerWidth }} open={customizeFormOpen} onClose={closeCustomizeForm}>
        <CustomizeForm stallItemBatchId={stallItemBatchId} stallItemId={stallItemId}
          handleCustomizedDetails={handleCustomizedDetails} closeCustomizeForm={closeCustomizeForm} />
      </Drawer>
      <Dialog
        open={imageSlideOpen}
        onClose={handleImageSlideClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <ImageSlides imageConfig={imageConfig} handleImageSlideClose={handleImageSlideClose} />
      </Dialog>      
      <Dialog
        open={qtyAlertOpen}
        maxWidth="sm"
        fullWidth
        onClose={handleQtyAlertClose}
        aria-labelledby="stallitem-qty-alert-title"
        aria-describedby="stallitem-qty-alert-desc"
      >
        <ItemCustomizeAlert
          errorMessages={qtyAlertMessage}
          handleClose={handleQtyAlertClose}
        />
      </Dialog>
    </div>
  );
};

export default StallItem;